import React, { useState, useEffect } from 'react';
import { C } from 'shared/helpers';
import Styles from './MessageModal.module.scss';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
/**
 *
 * @param {Object} param0
 * @param {'error'} param0.type
 * @param {boolean} param0.visible
 * @param {any} param0.message
 * @param {() => void} param0.onDismiss
 * @param {any} param0.title
 */
export default function MessageModal({
  visible,
  message,
  type,
  onDismiss,
  title,
}) {
  const [currentMessage, setCurrentMessage] = useState(message);
  const [currentTitle, setCurrentTitle] = useState(title || (type === 'error' ? 'Falha na operação' : ''));
  useEffect(() => {
    if (message) setCurrentMessage(message);
  }, [message]);
  useEffect(() => {
    if (title) setCurrentTitle(title);
  }, [title]);
  return (
    <div className={C(Styles.Container, [visible, Styles.Visible])}>
      <div>
        <div>{currentTitle}</div>
        <FontAwesomeIcon size={'3x'} icon={type === 'error' ? faBan : ''} />
        <div className={Styles.MessageContainer}>{currentMessage}</div>
        <button onClick={onDismiss}>Ok</button>
      </div>
    </div>
  );
}
